<template lang="pug">
.v-new-slider.new-slider(v-if="sliderData" :id="uniqueId")
	.new-slider__container.container
		.new-slider__buttons
			.new-slider__button
				button.btn.btn--primary(type="button" ref="prev") Prev
			.new-slider__button
				button.btn.btn--primary(type="button" ref="next") Next
			.new-slider__button
				button.btn.btn--primary(type="button" @click="slideTo(3)") Slide to #2
		.new-slider__slider-wrapper
			v-swiper-slider(ref="slider"
					:options="options"
					:pagination="pagination"
					:navigation="navigation"
					:scrollbar="scrollbar"
					@swiper="onSwiper")
				swiper-slide.new-slider__slide(v-for="(item, index) in sliderData.items" :key="index")
					.new-slider__slide-title(v-if="item.title") {{item.title}}
					.new-slider__slide-text.flc(v-if="item.text") {{item.text}}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import { SwiperSlide } from 'swiper/vue';
import breakpoints from '../scripts/breakpoints.js';

export default {
	components: {
		SwiperSlide
	},

	mixins: [
		sourceMixin
	],

	data() {
		return {
			uniqueId: uniqueId('swiper-slider-'),
			sliderData: null,
			options: {
				slidesPerView: 1,
				loop: false,
				spaceBetween: 24,
				// атрибуты aria-label для кнопок-стрелок
				a11y: {
					prevSlideMessage: 'Previous slide',
					nextSlideMessage: 'Next slide',
				},
				breakpoints: {
					[breakpoints['lg-min']]: {
						slidesPerView: 4
					},
					[breakpoints['md-min']]: {
						slidesPerView: 3
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 2
					}
				}
			},
			// если скроллбар не нужен, то все равно должен передаваться объект c el: null
			//scrollbar: {
			//	el: null
			//},
			scrollbar: {
				draggable: true
			},
			// если будеты не нужны, то все равно должен передаваться объект c el: null
			//pagination: {
			//	el: null
			//},
			pagination: {
				clickable: true
			},
			navigation: false
		};
	},

	methods: {
		slideTo(index) {
			this.$refs['slider'].slideTo(index);
		},

		// можно повесить обработчик и напрямую а не через navigation
		//slideNext() {
		//	this.$refs['slider'].slideNext();
		//},

		//slidePrev() {
		//	this.$refs['slider'].slidePrev();
		//},

		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		dataSet(data) {
			this.sliderData = data;
		}
	}
};
</script>